import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import { SCREEN_SIZE } from '../../lib/Media'
import { EventTrackingConsumer } from '../EventTrackingProvider/EventTrackingProvider'
import { AMP_EVENT_NAME, getPageTypeByUrl } from '../../lib/amplitude'
import { getCtaLocationMeta } from '../../lib/utils'
import { GTM_ENV_VAR as GEV } from '../../lib/eventTrackerFunction'

const Arrow = styled.i`
  margin: auto 0;
  &:before {
    content: '';
    border: solid #333333;
    border-width: 0 1px 1px 0;
    display: block;
    padding: 2px;
    transform: ${props =>
      props.direction === 'left' ? 'rotate(135deg)' : 'rotate(-45deg)'};
  }
`

const StyledLink = styled.a`
  margin: 0.2rem 0.5rem;
  text-decoration: none;
  font-size: 0.75rem;
  color: ${defaultTheme.ColorBaseBrandPrimary500};
  &:visited {
    color: ${defaultTheme.ColorBaseBrandPrimary500};
  }
`

const FromTabletDisplay = styled.div`
  display: none;
  ${SCREEN_SIZE.From.Tablet} {
    display: flex;
    margin-right: auto;
  }
`

const OnlyMobileDisplay = styled.div`
  display: none;
  ${SCREEN_SIZE.Only.Mobile} {
    display: flex;
    margin-right: auto;
  }
`

class Breadcrumb extends React.Component {
  constructor(props) {
    super(props)
    this.handleCategoryClick = this.handleCategoryClick.bind(this)
  }

  generateCategoryHierarchy(category) {
    let currentCategory = category
    const categories = [currentCategory]
    while (currentCategory.parentCategory) {
      currentCategory = currentCategory.parentCategory
      categories.unshift(currentCategory)
    }

    categories.unshift({
      slug: '/',
      name: 'Home',
    })

    return categories
  }

  handleCategoryClick(level, name) {
    if (level !== 0) {
      this.props.track({
        [GEV.AMPLITUDE_EVENT_NAME]: AMP_EVENT_NAME.CATEGORY_CLICKED,
        [GEV.AMPLITUDE_CATEGORY_NAME]: name,
        [GEV.AMPLITUDE_CATEGORY_LEVEL]: level,
        [GEV.AMPLITUDE_CTA_LOCATION]: {
          pageName: getPageTypeByUrl(),
          pageMeta: getCtaLocationMeta() || [],
        },
      })
    }
  }

  render() {
    const { category } = this.props

    if (!category) {
      return null
    }

    const categories = this.generateCategoryHierarchy(category)
    return (
      <React.Fragment>
        <FromTabletDisplay>
          {categories &&
            categories.length > 0 &&
            categories.map((categoryData, index) => {
              return (
                <React.Fragment key={`category-${index}`}>
                  <Link
                    href={
                      categoryData.slug !== '/'
                        ? `/categoryDetails?slug=${categoryData.slug}`
                        : `/`
                    }
                    as={
                      categoryData.slug !== '/'
                        ? `/category/${categoryData.slug}`
                        : `/`
                    }
                    passHref
                    legacyBehavior
                  >
                    <StyledLink
                      onClick={() =>
                        this.handleCategoryClick(index, categoryData.name)
                      }
                    >
                      {categoryData.name}
                    </StyledLink>
                  </Link>
                  {index < categories.length - 1 && <Arrow />}
                </React.Fragment>
              )
            })}
        </FromTabletDisplay>
        <OnlyMobileDisplay>
          {categories && categories.length > 0 && (
            <React.Fragment>
              <Arrow direction="left" />
              <Link
                href={
                  categories[categories.length - 1].slug !== '/'
                    ? `/categoryDetails?slug=${
                        categories[categories.length - 1].slug
                      }`
                    : `/`
                }
                as={
                  categories[categories.length - 1].slug !== '/'
                    ? `/category/${categories[categories.length - 1].slug}`
                    : `/`
                }
                passHref
                legacyBehavior
              >
                <StyledLink>
                  {categories[categories.length - 1].name}
                </StyledLink>
              </Link>
            </React.Fragment>
          )}
        </OnlyMobileDisplay>
      </React.Fragment>
    )
  }
}

const BreadcrumbWrapper = props => (
  <EventTrackingConsumer>
    {({ track }) => <Breadcrumb {...props} track={track} />}
  </EventTrackingConsumer>
)

export default BreadcrumbWrapper
